import React from 'react';
import { useRootState } from 'store/StateProvider';
import Input from 'components/forms/Input/Input';
import 'components/AssumptionsDrawer/assumptions-drawer.scss';

const PricingTable = () => {
    const {
        assumptions,
        location: { isDell },
    } = useRootState();

    if (isDell) return null;
    return (
        <table className="pricing-table table">
            <thead>
                <tr>
                    <th>Pricing ($/TB/month)</th>
                    <th>Hybrid WL</th>
                    <th>Cloud WL</th>
                    <th> </th>
                </tr>
            </thead>
            <tbody>
                {assumptions.hybridPricing.data.map((row) => (
                    <tr key={row.pricing}>
                        <td>{row.pricing}</td>
                        <td className="table-cell-editable">
                            $
                            <Input
                                type="number"
                                name={`hybridPricing.${row.key}`}
                                isEditable={assumptions.isEditing}
                                defaultValue={assumptions.hybridPricing[row.key]}
                                className="qa-input-assumption-pricing-hybrid"
                            />
                        </td>
                        <td className="table-cell-editable">
                            $
                            <Input
                                type="number"
                                name={`cloudNativePricing.${row.key}`}
                                isEditable={assumptions.isEditing}
                                defaultValue={assumptions.cloudNativePricing[row.key]}
                                className="qa-input-assumption-pricing-cloud-native"
                            />
                        </td>
                        <td>{row.perMonth}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default React.memo(PricingTable);
